import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NG2PAGESCROLL_SERVICE_PROVIDER, PageScrollService } from './ng2-page-scroll.service';
import { PageScroll } from './ng2-page-scroll.directive';
import * as ɵngcc0 from '@angular/core';
var Ng2PageScrollModule = (function () {
    function Ng2PageScrollModule() {
    }
    /** @deprecated since v4.0.0-beta.10 (https://github.com/Nolanus/ng2-page-scroll/pull/190) */
    Ng2PageScrollModule.forRoot = function () {
        return {
            ngModule: Ng2PageScrollModule,
            providers: [
                { provide: PageScrollService, useClass: PageScrollService }
            ]
        };
    };
    /** @nocollapse */
    Ng2PageScrollModule.ctorParameters = function () { return []; };
Ng2PageScrollModule.ɵfac = function Ng2PageScrollModule_Factory(t) { return new (t || Ng2PageScrollModule)(); };
Ng2PageScrollModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: Ng2PageScrollModule });
Ng2PageScrollModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [NG2PAGESCROLL_SERVICE_PROVIDER], imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Ng2PageScrollModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [PageScroll],
                exports: [PageScroll],
                providers: [NG2PAGESCROLL_SERVICE_PROVIDER]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(Ng2PageScrollModule, { declarations: function () { return [PageScroll]; }, imports: function () { return [CommonModule]; }, exports: function () { return [PageScroll]; } }); })();
    return Ng2PageScrollModule;
}());
export { Ng2PageScrollModule };

